// extracted by mini-css-extract-plugin
module.exports = {"startPageBox":"styles_startPageBox__3Q7Tt"};